import React, { useEffect } from 'react';

import Header from './MainHeader';  // Assuming Header is a separate component



import '../styles/ViewAll.css'
import RoomSection from './RoomSection';

import YogaAndPoolSection from './YogaAndPoolSection';
import DiningAndLoungeSection from './DiningAndLoungeSection';
import Footer from './Footer';
import '../styles/HotelFacilitiesSection.css'
import RoomBookingSection from './RoomSearch';
import "../styles/style.css"
import '../styles/HeroSearchSection.css';
import '../bbkandy/css/hotale-style-custom.css'
import '../bbkandy/css/style-core.css'
import '../bbkandy/css/style.css'
import '../bbkandy/css/tourmaster-global-style-custom.css'
import '../bbkandy/css/tourmaster-room-style-custom.css'
import '../bbkandy/css/custom.css'
import HotelFacilitiesSection from './HotelFacilitiesSection';
import KandySection from './KandySection';



const Home = () => {
  useEffect(() => {
    // Set the page title
    document.title = 'BananaBunks-kandy';
  }, []);


  //const currentDate = new Date();

  return (
    <body >
      <div className='Main'>


        <main>
          <Header />
          
          

          <div className="hotale-page-wrapper" id="hotale-page-wrapper">
            <div className="gdlr-core-page-builder-body">

              <div
  className="gdlr-core-pbf-wrapper hero-wrapper"
  id="gdlr-core-wrapper-1"
  style={{
    position: 'relative',
    overflow: 'hidden',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    paddingTop: '350px', // Added space at top to prevent image cutoff
    paddingBottom: '80px' // Added space at bottom
  }}
>
  {/* Background Image with Parallax Effect - Now with full visibility */}
  <div className="gdlr-core-pbf-background-wrap" style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1
  }}>
    <div
      className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
      style={{
        backgroundImage: 'url(/bbkandy/images/slider/1.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundAttachment: 'fixed',
        zIndex: '1',
        inset: 0,
        filter: 'brightness(1)' // Restored full brightness
      }}
      data-parallax-speed="0"
    ></div>
    {/* Lighter Overlay */}
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.2)' // Lighter overlay
    }}></div>
  </div>

  {/* Content */}
  <div className="gdlr-core-pbf-wrapper-content gdlr-core-js" style={{
    position: 'relative',
    zIndex: 2,
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px'
  }}>
    <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%'
    }}>
      {/* Hero Title Section - Updated with Yellowtail font */}
      <div
        className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first"
        id="gdlr-core-column-1"
        style={{
          width: '100%',
          maxWidth: '800px',
          marginBottom: '220px' // Added space between title and search section
        }}
      >
        <div
          className="gdlr-core-pbf-column-content-margin gdlr-core-js"
          style={{ 
            textAlign: 'center',
            padding: '0',
            width: '100%'
          }}
        >
          <div className="gdlr-core-pbf-element">
            <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
              <div className="gdlr-core-title-item-title-wrap" style={{ width: '100%' }}>
                <h3 
                  className="gdlr-core-title-item-title gdlr-core-skin-title"
                  style={{
                    color: 'white',
                    fontSize: '80px',
                    fontFamily: '"Yellowtail", cursive',
                    fontWeight: 400,
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
                    margin: '0 auto',
                    padding: '0 20px',
                    lineHeight: '96px',
                    letterSpacing: '0px',
                    textTransform: 'none'
                  }}
                >
                  Oasis of Good Living
                </h3>
                {/* Removed the divider line completely */}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Room Booking Section with proper spacing */}
      <div style={{ 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'center',
        marginTop: '40px' // Additional space above search section
      }}>
        <RoomBookingSection />
      </div>
    </div>
  </div>
</div>

              <div style={{ margin: 0, padding: 0 }}>

                
                <KandySection />
                <RoomSection />
                
                

              </div>

              

{/* Video Section */}
                        <div className="gdlr-core-pbf-wrapper videopadding" id="gdlr-core-wrapper-6">
                            <div className="gdlr-core-pbf-background-wrap">
                                <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js">
                                    <img className="vid_pic" src="/bbkandy/images/home/3.webp" alt="" />
                                </div>
                            </div>
                        </div>

             



              <div className="gdlr-core-pbf-element bbkandybg" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '50px 20px 18px 20px' }}>
                <div
                  className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                  id="gdlr-core-title-item-2"
                  style={{ textAlign: 'center' }} // This centers the text within the block
                >
                  <div className="gdlr-core-title-item-title-wrap green_back_second">
                    <h3
                      className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font"
                      style={{
                        fontSize: '80px',
                        fontWeight: '500',
                        letterSpacing: '0px',
                        textTransform: 'none',
                      }}
                    >
                      Enjoy your every moment
                    </h3>
                    <div className="lower-text bodyfont">Explore our range of facilities</div>
                  </div>
                </div>
              </div>



              <YogaAndPoolSection />
              <DiningAndLoungeSection />
              <HotelFacilitiesSection />


            </div>
          </div>
        </main >
        <Footer />
      </div >
    </body>
  );
};

export default Home;
